import { CalloutColor, ContentBlockType, SimpleCalloutBlock } from '../../../model';

export const DEFAULT_SIMPLE_CALLOUT_PROPS = {
  title: 'Callout',
  color: CalloutColor.Sky,
  icon: 'info-circle',
  type: ContentBlockType.SimpleCallout,
  content: [],
} as const satisfies Partial<SimpleCalloutBlock>;
